<template>
  <div>
    <div v-if="productKey === 'a194FDVK89n'">
      <el-button type="primary" @click="handler('open')">打开窗帘</el-button>
      <el-button type="primary" @click="handler('stop')">停止窗帘</el-button>
      <el-button type="primary" @click="handler('close')">关闭窗帘</el-button>
    </div>
    <div v-else>
      <el-button type="primary" @click="handler('restartPaner')">重启面板</el-button>
    </div>
  </div>
</template>
<script>
import { messageIssued } from '@/api/deviceManagement'
export default {
  props: {
    productKey: {
      type: String
    },
    deviceName: {
      type: String || null
    }
  },
  data () {
    return {
    }
  },
  created () {
    console.log(this.deviceName, this.productKey)
  },
  methods: {
    handler (val) {
      console.log(this.productKey)
      const params = {
        deviceName: this.deviceName,
        productKey: this.productKey,
        // topicClassTemp: '/sys/a194FDVK89n/$' + '{deviceName}/thing/service/property/set',
        topicClassTemp: `/sys/${this.productKey}/$` + '{deviceName}/thing/service/property/set',
        msg: {
          id: new Date().getTime() + '',
          version: '1.0',
          params: {
          // # 0 关闭 ， 1 打开窗帘  2 停止窗帘
            // curtainConrtol: 0
          },
          timestamp: new Date().getTime(),
          method: 'thing.service.property.set'
        }
      }
      switch (val) {
        case 'close':
          console.log(11)
          params.msg.params.curtainConrtol = 0
          break
        case 'open':
          console.log(22)
          params.msg.params.curtainConrtol = 1
          break
        case 'stop':
          console.log(33)
          params.msg.params.curtainConrtol = 2
          break
        case 'restartPaner':
          params.msg.params.reboot = 3
          break
      }
      messageIssued(params).then(res => {
        if (res.data.code === 200) {
          this.$message({
            type: 'success',
            message: res.data.message
          })
        }
      })
    }
  }
}
</script>

<style lang='less' scoped>

</style>
